import videoService from '../../services/video';

let num = 1;

const types = {
  GET_VIEW_VIDEO_LIST: 'videoService/getViewVideoList',
  GET_VIEW_VIDEO_LIST_TOTAL_PAGES: 'videoService/getViewVideoListTotalPages',

  GET_NEW_SLIDE_VIDEO_LIST: 'videoService/getNewSlideVideoList',
  GET_VIEW_SLIDE_VIDEO_LIST: 'videoService/getViewSlideVideoList',

  GET_VIDEO_TOTAL_PAGES: 'videoService/getVideoTotalPages', 
  GET_PAGES_VIDEO_LIST: 'videoService/getPagesVideoList',
  GET_PAGES_SORT_VIDEO_LIST: 'videoService/getPagesSortVideoList',
  GET_BANNER_VIDEO_LIST: 'videoService/getBannerVideoList',
  GET_VIDEO_LIST: 'videoService/getVideoList',
  GET_MORE_VIDEO_LIST: 'videoService/getVideoMoreList',

  GET_ADVERTISERS_LIST: 'videoService/getAdvertisersList',
  GET_ADVERTISERS_VIDEO: 'videoService/getAdvertisersVideo',
};

const state = {
  videoViewList: [],
  videoViewTotalPages: 0,

  videoNewSlideList: [],
  videoViewSlideList: [],

  videoTotalPages: 0,

  videoList: [],
  videoPagesList: [],
  videoBannerList: [],

  advertisersVideoList: [],
  advertiserName: null,
  advertisersVideo: {},
};

// getters 也可以整理到這邊直接返回 count 內容
const getters = {

  // View List
  getViewVideoList: s => s.videoViewList,
  getViewVideoListTotalPages: s => s.videoViewTotalPages,

  getNewSlideVideoList: s => s.videoNewSlideList,
  getViewSlideVideoList: s => s.videoViewSlideList,

  getVideoTotalPages: s => s.videoTotalPages,
  getPageVideoList: s => s.videoPagesList,
  getBannerVideoList: s => s.videoBannerList,

  getVideoList: s => s.videoList,

  getAdvertisersVideoList: s => s.advertisersVideoList,
  getAdvertiserName: s => s.advertiserName,
  getAdvertisersVideo: s => s.advertisersVideo,

  getLoading: s => s.loading,
};

const actions = {

  actionViewVideosList({ commit }, pageNum) {
    videoService
    .getVideoViewList(pageNum)
    .then((res) => { 

      const {
        data,
        total_pages,
      } = res;

      commit(types.GET_VIEW_VIDEO_LIST, data);
      commit(types.GET_VIEW_VIDEO_LIST_TOTAL_PAGES, total_pages);
    })
    .catch(() => {
      // commit(rootypes.isShowRootLoading);
    });
  },

  actionViewSlideVideosList({ commit }) {
    videoService
    .getViewSlideVideoList()
    .then((res) => { 

      const {
        data,
      } = res;

      commit(types.GET_VIEW_SLIDE_VIDEO_LIST, data);
    })
    .catch(() => {
      // commit(rootypes.isShowRootLoading);
    });
  },

  actionNewSlideVideosList({ commit }) {
    videoService
    .getNewSlideVideoList()
    .then((res) => { 

      const {
        data,
      } = res;

      commit(types.GET_NEW_SLIDE_VIDEO_LIST, data);
    })
    .catch(() => {
      // commit(rootypes.isShowRootLoading);
    });
  },

  actionBannerVideosList({ commit }) {
    videoService
    .getBannerVideoList()
    .then((res) => { 

      const {
        _data,
      } = res;

      commit(types.GET_BANNER_VIDEO_LIST, _data);
    })
    .catch(() => {
      // commit(rootypes.isShowRootLoading);
    });
  },
  actionGetVideoList({ commit }) {

    videoService
    .getVideoList()
    .then((res) => { 

      const {
        _data,
      } = res;

      commit(types.GET_VIDEO_LIST, _data);
    })
    .catch(() => {
      // commit(rootypes.isShowRootLoading);
    });
    
  },
  actionGetMoreVideoListUsePage({ commit }, pageId) {

    videoService
    .getMoreVideoList(pageId)
    .then((res) => { 

      const {
        data,
        total_pages,
      } = res;

      commit(types.GET_PAGES_VIDEO_LIST, data);
      commit(types.GET_VIDEO_TOTAL_PAGES, total_pages);
    })
    .catch(() => {
      // commit(rootypes.isShowRootLoading);
    });
  },
  actionGetMoreVideoList({ commit }, loading) {

    videoService
    .getMoreVideoList(num)
    .then((res) => { 

      const {
        _data,
        _nextPage,
      } = res;

      if (_nextPage !== null) {
        commit(types.GET_MORE_VIDEO_LIST, _data);
        num += 1;
        loading.$emit('$InfiniteLoading:loaded');
      } else {
        loading.$emit('$InfiniteLoading:complete');
      }

      
    })
    .catch(() => {
      // commit(rootypes.isShowRootLoading);
    });
  },
  actionGetAdvertisersList({ commit }, advertiserId) {

    videoService
    .getAdvertisersList(advertiserId)
    .then((res) => { 

      const {
        _data,
      } = res;

      const advertiserName = _data[0].client.name;

      const options = {
        result: _data,
        advertiserName,
      };

      commit(types.GET_ADVERTISERS_LIST, options);
      
    })
    .catch(() => {
      // commit(rootypes.isShowRootLoading);
    });
    
  },

  actionGetAdvertisersVideo({ commit }, params) {
    
    const {
      advertiser_id,
      id,
    } = params;

    videoService
    .getAdvertisersVideo(advertiser_id, id)
    .then((res) => {
      
      const {
        _data,
      } = res;

      commit(types.GET_ADVERTISERS_VIDEO, _data);
    })
    .catch(() => {
      // commit(rootypes.isShowRootLoading);
    });
    
  },
};

// mutations
const mutations = {
  [types.GET_VIEW_VIDEO_LIST](s, p) {
    s.videoViewList = p;
  },
  [types.GET_VIEW_VIDEO_LIST_TOTAL_PAGES](s, p) {
    s.videoViewTotalPages = p;
  },
  [types.GET_NEW_SLIDE_VIDEO_LIST](s, p) {
    s.videoNewSlideList = p;
  },
  [types.GET_VIEW_SLIDE_VIDEO_LIST](s, p) {
    s.videoViewSlideList = p;
  },

  [types.GET_VIDEO_TOTAL_PAGES](s, p) {
    s.videoTotalPages = p;
  },
  [types.GET_BANNER_VIDEO_LIST](s, d) {

    const bannerList = d;
    const newBannerList = [];

    bannerList.forEach((banner) => {
      newBannerList.push({
        url: banner.slider_url ? banner.slider_url : banner.thumbnail_url,
        href: `${location.href}advertisers/${banner.client.id}/videos/${banner.video_id}`,
        name: banner.video_name,
        showDescription: banner.description,
        word: banner.description,
        client: banner.client.name === null ? '' : banner.client.name,
        category: banner.category.name === null ? '' : banner.category.name,
      });
    });

    s.videoBannerList = newBannerList;
  },

  // List Page
  [types.GET_PAGES_VIDEO_LIST](s, d) {
    s.videoPagesList = d;
  },

  [types.GET_PAGES_SORT_VIDEO_LIST](s, type) {

    switch (type) {
      case 'new': 
        s.videoPagesList = s.videoPagesList.sort((a, b) => {
          return new Date(b.start_date) - new Date(a.start_date);
        });
        break;
      case 'impression': 
        s.videoPagesList = s.videoPagesList.sort((a, b) => {
          return ((b.view_count + b.youtube_view_count) - (a.view_count + a.youtube_view_count));
        });
        break;
      default:
    }

  },

  [types.GET_VIDEO_LIST](s, d) {
    s.videoList = d;
  },
  [types.GET_MORE_VIDEO_LIST](s, d) {
    s.videoList = s.videoList.concat(d);
  },
  [types.GET_ADVERTISERS_VIDEO](s, d) {
    s.advertisersVideo = d;
  },
  [types.GET_ADVERTISERS_LIST](s, options) {
    s.advertisersVideoList = options.result;
    s.advertiserName = options.advertiserName;
  },
};

/*
  因為我們把 vuex 所有職權都寫在同一隻檔案，
  所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/video.js